import CustomerItemListFilter from './CustomerItemListFilter';

export default class CustomerItemListFilterAdmin extends CustomerItemListFilter {
	public itemNumber: string | null = null;

	public clear() {
		this.itemNumber = null;
	}

	public hasFilter(): boolean {
		return [this.itemNumber].some(x => x !== null);
	}
}
